import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import CategoryWiseReportsContent from '../CategoryWiseReportsContent';
import {
    setFromDate,
    setToDate,
    setSelectedBranch,
    fetchCategoryFullReport
} from '../../../store/slices/categoryWiseReportsSlice';

const CategoryWiseReports = () => {
    const dispatch = useDispatch();
    const storedBranchId = localStorage.getItem('branchid') || '';

    useEffect(() => {
        const toDate = new Date();
        const fromDate = new Date();
        fromDate.setDate(fromDate.getDate() - 30);
        dispatch(setFromDate(fromDate));
        dispatch(setToDate(toDate));
        dispatch(setSelectedBranch({ branch_id: storedBranchId || 'All', branch_name: 'Branch' }));
        dispatch(fetchCategoryFullReport({
            fromDate,
            toDate,
            branchId: storedBranchId || 'All'
        }));
    }, [dispatch, storedBranchId]);

    return <CategoryWiseReportsContent />;
};

export default CategoryWiseReports;

